import * as React from 'react';
import SelectDialog from './SelectDialog';

export interface SelectProps {
  open: boolean;
  title: string;
  options: string[];
  canClose: boolean;
  proceed: ((value?: string[]) => void) | null;
  reject: ((reason?: string) => void) | null;
  isMultiple: boolean;
}

export const SelectContext = React.createContext<
  [SelectProps, React.Dispatch<React.SetStateAction<SelectProps>>] | undefined
>(undefined);

export function SelectContextProvider({ children }: any) {
  const [select, setSelect] = React.useState<SelectProps>({
    open: false,
    title: '',
    options: ['____________________'],
    canClose: false,
    proceed: null,
    reject: null,
    isMultiple: false,
  });

  return (
    <SelectContext.Provider value={[select, setSelect]}>
      {children}
      <SelectDialog select={select} />
    </SelectContext.Provider>
  );
}
